export default __webpack_public_path__ + "static/media/11 3D (5-2).e78f70bc.jpg";